/* eslint-disable  */
// dont eslint because it's 3rd party code
/**
 * FROM https://github.com/AramRafeq/semantic-ui-carousel-react
 * Modified to use uuid instead of uniqid
 * LICENSE: MIT Licence
 Copyright (c) 2016-present, Udilia Inc.

 Permission is hereby granted, free of charge, to any person
 obtaining a copy of this software and associated documentation
 files (the "Software"), to deal in the Software without
 restriction, including without limitation the rights to use,
 copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the
 Software is furnished to do so, subject to the following
 conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 OTHER DEALINGS IN THE SOFTWARE.

 */
import React from "react";
import { Card,Transition, Button, Label } from "semantic-ui-react";
import "./Carousel.css";
class Carousel extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            currentIndex: 0
        };
    }
    componentDidMount()
    {
        if(this.props.onSlideChange) {
            this.props.onSlideChange(this.state.currentIndex,this.props.elements[this.state.currentIndex]);
        }

        if (this.props.duration)
        {

            this.interval = setInterval(() =>
            {
                this.nextSlide();
                try
                {
                    this.props.onSlideChange(this.state.currentIndex,this.props.elements[this.state.currentIndex]);
                }
                catch (e)
                {}
            }, this.props.duration);
        }
    }

    componentDidUpdate() {
        if((this.props.elements?.length- 1 ) < this.state.currentIndex){
            this.setState({currentIndex:0})
        }

        if(this.props.onSlideChange) {
            this.props.onSlideChange(this.state.currentIndex,this.props.elements[this.state.currentIndex]);
        }
    }

    componentWillUnmount()
    {
        if (this.props.duration)
        {
            clearInterval(this.interval);
        }
    }
    nextSlide()
    {
        const currentIndex = (this.state.currentIndex+1)%this.props.elements.length
        this.setState({ currentIndex });

        if(this.props.onSlideChange) {
            this.props.onSlideChange(currentIndex,this.props.elements[currentIndex]);
        }
    }
    prevSlide()
    {
        const currentIndex = ((this.state.currentIndex-1)%this.props.elements.length)<0 ? this.props.elements.length-1 :(this.state.currentIndex-1)%this.props.elements.length
        this.setState({ currentIndex });

        if(this.props.onSlideChange) {
            this.props.onSlideChange(currentIndex,this.props.elements[currentIndex]);
        }
    }
    gotToSlide(index)
    {
        if (this.props.duration)
        {
            clearInterval(this.interval);
        }
        this.setState({ currentIndex: index });

        if(this.props.onSlideChange) {
            this.props.onSlideChange(index,this.props.elements[index]);
        }
    }
    nextClicked()
    {
        if (this.props.duration)
        {
            clearInterval(this.interval);
        }
        this.nextSlide();
    }
    prevClicked()
    {
        if (this.props.duration)
        {
            clearInterval(this.interval);
        }
        this.prevSlide();
    }
    render()
    {
        return (
            <Card fluid className="carousel-container">
                <Card.Content className="carousel">
                    {
                        (this.props.elements).map((element, index) =>
                        {
                            if (this.state.currentIndex === index )
                            {
                                return (
                                    <Transition key={`index_${+new Date()}`} transitionOnMount={true} visible={true} duration={1000} animation={this.props.animation}>
                                        {this.props.elements[index].render()}
                                    </Transition>
                                );
                            }
                        })
                    }
                    <div className="carousel-indicators">
                        {
                            (this.props.showIndicators)
                                ? (this.props.elements).map((elemnt, index) =>
                                {
                                    if (this.state.currentIndex === index )
                                    {
                                        return (
                                            <a>
                                                <Label onClick = {() => this.gotToSlide(index) } circular color="black" empty  />
                                            </a>
                                        );
                                    }
                                    else
                                    {
                                        return (
                                            <a>
                                                <Label onClick = {() => this.gotToSlide(index) } circular color="grey" empty  />
                                            </a>
                                        );
                                    }
                                })
                                :null
                        }
                    </div>
                    {(this.props.showNextPrev && this.props.elements?.length > 1) ? <Button className="prev" onClick = {() => this.prevClicked()} icon="caret left" /> : null}
                    {(this.props.showNextPrev && this.props.elements?.length > 1) ? <Button className="next" onClick = {() => this.nextClicked()} icon="caret right" /> : null}
                </Card.Content>
            </Card>
        );
    }
}

export default Carousel;


